import { MdStoreMallDirectory } from "react-icons/md";
import { FaMotorcycle } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

export default function OnboardCards() {
  const navigate = useNavigate();

  return (
    <div className="mx-4 md:mx-6 lg:mx-14 py-10 md:py-16">

      {/* Section Heading */}
      <div className="text-center mb-12">
        <h2 className="text-[28px] md:text-[34px] font-extrabold text-[#023B64]">
          Operations & Partnerships
        </h2>
        <p className="text-gray-600 mt-2 text-base md:text-lg">
          Join the Tydii ecosystem and grow together with our network.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-10">

        {/* Business Store Card */}
        <div className="group bg-white rounded-2xl border border-gray-100 p-8 shadow-md hover:shadow-xl hover:-translate-y-1 transition-all duration-300 flex flex-col items-center">
          
          {/* Icon Box */}
          <div className="w-20 h-20 rounded-2xl bg-gradient-to-br from-[#02537F] to-[#0585CB] flex items-center justify-center text-white text-4xl mb-5 shadow-lg group-hover:scale-105 transition">
            <MdStoreMallDirectory />
          </div>

          <h3 className="text-[22px] font-bold text-[#023B64] mb-3 text-center">
            Become a Tydii Business Partner
          </h3>

          <p className="text-gray-600 text-center leading-relaxed mb-6 px-2">
            Grow your laundry store with fast onboarding, high customer demand,
            and consistent orders through the Tydii platform.
          </p>

          <button
            onClick={() => navigate("/laundry-business")}
            className="mt-auto bg-[#02537F] hover:bg-[#096597] text-white py-2.5 px-7 rounded-lg font-semibold shadow-md group-hover:shadow-lg transition"
          >
            Business Store Onboard
          </button>
        </div>

        {/* Delivery Partner Card */}
        <div className="group bg-white rounded-2xl border border-gray-100 p-8 shadow-md hover:shadow-xl hover:-translate-y-1 transition-all duration-300 flex flex-col items-center">
          
          {/* Icon Box */}
          <div className="w-20 h-20 rounded-2xl bg-gradient-to-br from-[#035885] to-[#3AB5F8] flex items-center justify-center text-white text-4xl mb-5 shadow-lg group-hover:scale-105 transition">
            <FaMotorcycle />
          </div>

          <h3 className="text-[22px] font-bold text-[#023B64] mb-3 text-center">
            Become a Delivery Partner
          </h3>

          <p className="text-gray-600 text-center leading-relaxed mb-6 px-2">
            Earn more with flexible timings. Deliver laundry orders and make 
            money on your schedule with Tydii.
          </p>

          <button
            onClick={() => navigate("/delivery-partner")}
            className="mt-auto bg-[#02537F] hover:bg-[#096597] text-white py-2.5 px-7 rounded-lg font-semibold shadow-md group-hover:shadow-lg transition"
          >
            Delivery Partner Onboard
          </button>
        </div>

      </div>
    </div>
  );
}
